import { z } from 'zod';

export const CulinaryStudioArticleNonIncludedServiceModelSchema = z.object({
    name: z.string(),
});

export type CulinaryStudioArticleNonIncludedServiceModel
    = z.infer<typeof CulinaryStudioArticleNonIncludedServiceModelSchema>;
